<template>
  <div>
    <ts-card>
      <ts-card-wrapper>
        <div class="d-flex flex-column align-items-center">
          <ts-image-input
            class="employee-image-input"
            :file="model.photo ? model.photo : file"
            @input="file => (model.photo = file)"
            :width="175"
            :height="225"
            crop
          ></ts-image-input>
          <span>
            <i>{{$t('employeeProfile.employeePhoto')}}</i>
          </span>
          <div class="validate">{{ errors.first('photo') }}</div>
        </div>

			<div class="ts-space-y-3">
        <div>
          <label class="required" >{{ $t('employeeProfile.idCard') }}</label>
          <input
            type="text"
            v-model.trim="model.card_id"
            class="form-control kh-font"
            :class="{ 'is-invalid': errors.has('card_id') }"
          />
          <div class="invalid-feedback" v-if="errors.has('card_id')">{{ errors.first('card_id') }}</div>
        </div>
        <div>
          <label>{{ $t('employeeProfile.nameKh') }}</label>
          <input
            ref="employee_name_kh"
            type="text"
            v-model.trim="model.employee_name_kh"
            class="form-control kh-font"
            :class="{ 'is-invalid': errors.has('employee_name_kh') }"
          />
          <div class="invalid-feedback" v-if="errors.has('employee_name_kh')">{{ errors.first('employee_name_kh') }}</div>
        </div>
        <div>
          <label class="required">{{$t('employeeProfile.nameEn')}}
          </label>
          <input
            type="text"
            v-model.trim="model.employee_name_en"
            class="form-control"
            :class="{ 'is-invalid': errors.has('employee_name_en') }"
          />
          <div class="invalid-feedback" v-if="errors.has('employee_name_en')">{{ errors.first('employee_name_en') }}</div>
        </div>
        <div>
          <label class="required" >{{ $t('employeeProfile.gender') }}</label>
          <select class="form-control" v-model.number="model.sex">
						<option value="male">Male</option>
						<option value="female">Female</option>
          </select>
          <div class="invalid-feedback" v-if="errors.has('gender')">{{ errors.first('gender') }}</div>
        </div>
        <div>
          <label>{{ $t('employeeProfile.dateOfBirth') }}</label>
          	<a-date-picker 
							v-model="model.date_of_birth"
							valueFormat="DD-MM-YYYY"
							format="DD-MM-YYYY" 
							class="ts-w-full"
						></a-date-picker>
          <div class="validate">{{ errors.first('date_of_birth') }}</div>
        </div>
        <div>
          <label>{{ $t('employeeProfile.nationality') }}</label>
					<input v-model.trim="model.nationality" type="text" class="form-control">
          <div class="validate">{{ errors.first('nationality') }}</div>
        </div>
			</div>
      </ts-card-wrapper>
    </ts-card>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
export default {
  name: 'photoEmployee',
  props: ['value', 'validate'],
  data() {
    return {
      errors: new Errors(),
			file: require('../../../../assets/user_default.png'),
      model: {}
    }
  },
  created() {
    this.model = this.value
  },
  watch: {
    validate: function(error) {
      this.errors = new Errors(error.errors)
    }
  }
}
</script>

<style lang="scss">
.employee-image-input {
  background: #fff;
  border-radius: 5px;
  padding: 3px;
  -webkit-box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}
</style>